module.exports = __webpack_public_path__ + "media/images/map_preview_landscape-07b7144e84dd51ac5ea6f972b66bc4cd.png";